import React from "react";
import { 
  Box, 
  Typography, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from "@mui/material";

const testCases = [
  { id: "TC001", test: "Search for valid products", status: "Passed", notes: "N/A" },
  { id: "TC002", test: "Search for invalid products", status: "Passed", notes: "N/A" },
  { id: "TC003", test: "Auto-suggestion behavior", status: "Passed", notes: "Delay in display; logic needs optimization." },
  { id: "TC004", test: "Filter Persistence", status: "Passed", notes: "N/A" },
  { id: "TC005", test: "Search history", status: "Passed", notes: "N/A" },
  { id: "TC006", test: "Mobile responsiveness", status: "Passed", notes: "N/A" },
  { id: "TC007", test: "Performance", status: "Passed", notes: "Influence by network speed." },
  { id: "TC008", test: "Result accuracy", status: "Partially Failed", notes: "Search too literal. Implement fuzzy search." },
  { id: "TC009", test: "Add to cart functionality", status: "Passed", notes: "Success message is clear." },
  { id: "TC010", test: "Cart persistence", status: "Passed", notes: "N/A" },
  { id: "TC011", test: "Quantity Update", status: "Failed", notes: "Calculation error: (+ 1 Ksh added)." },
  { id: "TC012", test: "Remove item quantity", status: "Partially Passed", notes: "Improve UX for removal at qty 1." },
];

export default function JumiaQAReport() {
  return (
    <Box sx={{ py: 8, px: 2, maxWidth: 1000, mx: "auto" }}>
      <Typography variant="h4" sx={{ mb: 4, color: "primary.main", fontWeight: "bold" }}>
        Jumia E-Commerce QA Report
      </Typography>
      
      <TableContainer component={Paper} sx={{ bgcolor: "background.paper", borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "action.hover" }}>
              <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Test Case</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {testCases.map((tc) => (
              <TableRow key={tc.id} hover>
                <TableCell>{tc.id}</TableCell>
                <TableCell>{tc.test}</TableCell>
                <TableCell sx={{ 
                  color: tc.status.includes('Failed') ? 'error.main' : 'success.main',
                  fontWeight: 500
                }}>
                  {tc.status}
                </TableCell>
                <TableCell sx={{ color: "text.secondary" }}>{tc.notes}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}